import { aws } from './awsdb';

// Client-side logger for lower-stakes Vault events: `credential_viewed`
// (opening a credential's Details) and `credential_copied` (copying an
// already-revealed password to the clipboard).
//
// credential_revealed is deliberately NOT written from here — it is
// written server-side inside the vault-reveal Lambda so a reveal can never
// happen without the log entry landing. See app/src/lib/vaultReveal.js.
// credential_copied can only happen after a reveal already succeeded (and
// got logged that way), so a client-side log for the copy itself is fine.
export function logVaultActivity(credentialId, session, { action_type, detail } = {}) {
  return aws.from('vault_activity_log').insert([{
    credential_id: credentialId ?? null,
    actor_code: session.code,
    actor_name: session.name,
    action_type,
    detail: detail ?? null,
  }]);
}
